export default "__VITE_ASSET__372c6244__"